// Mirror of the backend permission catalog. Resources expose
// `{resource}.view` / `{resource}.manage`; standalone actions live in `Permission`.

export type AccessLevel = 'editor' | 'view' | 'closed';

export enum Resource {
  DASHBOARD = 'dashboard',
  PROFILE = 'profile',
  REGION = 'region',
  PICKUP = 'pickup',
  CATEGORY = 'category',
  FILTER = 'filter',
  POPULAR_CATEGORY = 'popular_category',
  PRODUCT = 'product',
  PRODUCT_OF_MONTH = 'product_of_month',
  TOP_PRODUCT = 'top_product',
  STOCK_BALANCE = 'stock_balance',
  ORDER = 'order',
  IMPORT_PRICE = 'import_price',
  IMPORT_PRODUCT = 'import_product',
  IMPORT_LIST = 'import_list',
  QR_GENERATION = 'qr_generation',
  ADMIN_PANEL = 'admin_panel',
  SITE_USER = 'site_user',
  PARTNER = 'partner',
  BANNER = 'banner',
  SUBSCRIPTION = 'subscription',
  SETTING = 'setting',
  SEO = 'seo',
  FEED = 'feed',
  COMMISSION = 'commission',
  FEEDBACK = 'feedback',
  CONTENT = 'content',
  CASH_REGISTER = 'cash_register',
}

// Standalone action permissions (orthogonal to view/manage).
export const Permission = {
  PARTNER_LOGIN_AS: 'partner.login_as',
  SITE_USER_VIEW_CONTACTS: 'site_user.view_contacts',
  ORDER_DELETE: 'order.delete',
  ORDER_RESTORE: 'order.restore',
  FEEDBACK_DELETE: 'feedback.delete',
} as const;

export type PermissionKey = (typeof Permission)[keyof typeof Permission];
